<template>
  <div id="profile-page">
    <page-header-component
      icon="bi bi-person-gear"
      title="Profile"
      :hide-filter="true"
    />
    <transition name="block">
      <div v-if="mounted" class="row">
        <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12">
          <div class="row">
            <div class="col-md-8 px-gap">
              <loader-component
                v-if="is_loading"
                :with_text="true"
                text="Loading"
              />
              <transition v-else name="block">
                <div class="form bg-white shade p-3 h-100">
                  <h5>Data Diri</h5>
                  <form action="#" @submit.prevent="saveProfile">
                    <div class="form-group">
                      <label for="input_nama">Nama</label>
                      <input
                        type="text"
                        name="nama"
                        v-model="user_data.nama"
                        class="form-control form-custom"
                        placeholder="Nama Lengkap"
                        required
                      />
                    </div>
                    <div class="form-group">
                      <label for="input_username">Username</label>
                      <input
                        type="text"
                        name="username"
                        v-model="user_data.username"
                        class="form-control form-custom"
                        placeholder="Username"
                        readonly="true"
                        required
                      />
                    </div>
                    <div class="form-group">
                      <label for="input_phone">No Kontak</label>
                      <input
                        type="text"
                        name="phone"
                        v-model="user_data.phone"
                        value=""
                        class="form-control form-custom"
                        placeholder="No Kontak"
                      />
                    </div>
                    <div class="form-group">
                      <label for="input_email">Email</label>
                      <input
                        type="text"
                        name="email"
                        v-model="user_data.email"
                        value=""
                        class="form-control form-custom"
                        placeholder="Email"
                      />
                    </div>
                    <div class="form-group" align="right">
                      <button
                        class="btn btn-icon-left btn-success"
                        type="submit"
                        title="Simpan Data"
                      >
                        <i class="bi bi-person-check"></i> Simpan
                      </button>
                    </div>
                  </form>
                </div>
              </transition>
            </div>
            <div class="col-md-4 px-gap">
              <div class="bg-white shade p-3 mb-4">
                <h5>Data Project</h5>
                <div class="form-group">
                  <label for="input-old-password">ID Project</label>
                  <input
                    v-model="id_project"
                    class="form-control form-custom"
                    disabled
                  />
                </div>
                <div class="form-group">
                  <label for="input-old-password">Nama Project</label>
                  <input
                    v-model="nama_project"
                    class="form-control form-custom"
                    disabled
                  />
                </div>
              </div>
              <div class="bg-white shade p-3">
                <h5>Ubah Password</h5>
                <div class="error-messages" v-if="change_password_error">
                  <alert-dynamic-component
                    :key="notif_password_key"
                    type="danger"
                    title="<i class='bi bi-x-circle'></i> Terjadi Kesalahan!<br>"
                    :subtitle="error_message"
                  />
                </div>
                <form
                  action="#"
                  @submit.prevent="changePassword"
                  id="change-password-form"
                >
                  <div class="form-group">
                    <label for="input-old-password">Password Lama</label>
                    <input
                      type="password"
                      v-model="old_password"
                      class="form-control form-custom"
                      name="old-password"
                      value=""
                      placeholder="Password Lama"
                      required
                    />
                  </div>
                  <div class="form-group">
                    <label for="input-new-password">Password Baru</label>
                    <input
                      type="password"
                      v-model="new_password"
                      class="form-control form-custom"
                      name="new-password"
                      value=""
                      placeholder="Password Baru"
                      required
                    />
                  </div>
                  <div class="form-group">
                    <label for="input-new-password-confirm"
                      >Konfirmasi Password Baru</label
                    >
                    <input
                      type="password"
                      v-model="new_password_confirmation"
                      class="form-control form-custom"
                      name="new-password-confirm"
                      value=""
                      placeholder="Konfirmasi Password Baru"
                      required
                    />
                    <span v-if="password_different" class="text-danger"
                      ><i class="bi bi-info-circle" /> Password baru tidak
                      sama</span
                    >
                  </div>
                  <div class="form-group" align="right">
                    <button
                      v-if="password_different"
                      class="btn btn-icon-left btn-success disabled"
                      disabled
                      type="button"
                      title="Ubah Password"
                    >
                      <i class="bi bi-person-lock"></i
                      ><span>Ubah Password</span>
                    </button>
                    <button
                      v-else
                      class="btn btn-icon-left btn-success"
                      type="submit"
                      title="Ubah Password"
                    >
                      <i class="bi bi-person-lock"></i
                      ><span>Ubah Password</span>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <floating-loader-component v-if="is_loading_floating" />
  </div>
</template>

<script>
import $ from "jquery";
import page_header from "@/views/components/page_header.vue";
import gp from "@/plugins/generalPlugins.js";
import alert_dynamic from "@/views/components/alert_dynamic.vue";
import loader from "@/views/components/loader.vue";
import floating_loader from "@/views/components/floating_loader.vue";
import notifjs from "@/assets/js/notif.js";
$.pgNotification = notifjs;

export default {
  name: "Profile",
  title: "Profile | Online Media Monitoring",
  components: {
    "page-header-component": page_header,
    "alert-dynamic-component": alert_dynamic,
    "loader-component": loader,
    "floating-loader-component": floating_loader,
  },
  data() {
    return {
      data: this.$store.getters.user,
      token_expire: "",
      user_data: null,
      is_loading: false,
      is_loading_floating: false,
      old_password: null,
      new_password: null,
      new_password_confirmation: null,
      change_password_error: false,
      error_message: "",
      password_different: false,
      mounted: false,
      notif_password_key: 0,
      id_project: this.$store.getters.user.id_project,
      nama_project: this.$store.getters.user.project.project_detail.name,
    };
  },
  methods: {
    getData: function () {
      let api = process.env.VUE_APP_API_URL + "user/" + this.data.user_id.$oid;
      this.is_loading = true;
      this.$http
        .get(api)
        .then((response) => {
          if (response.status == 200) {
            this.user_data = response.data;
          } else {
            this.user_data = {};
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    changePassword: function () {
      let api = process.env.VUE_APP_API_URL + "change-password";

      let param = {
        _id: this.user_data._id.$oid,
        old_password: btoa(this.old_password),
        new_password: btoa(this.new_password),
        new_password_confirm: btoa(this.new_password_confirmation),
      };
      this.is_loading_floating = true;
      this.change_password_error = false;
      this.$http
        .post(api, param)
        .then((response) => {
          if (response.status == 200) {
            this.change_password_error = false;
            this.old_password = null;
            this.new_password = null;
            this.new_password_confirmation = null;

            $("body")
              .pgNotification({
                style: "bar",
                message:
                  '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Password berhasil diubah.',
                position: "top",
                timeout: 5000,
                type: "success",
              })
              .show();
          }
        })
        .catch((error) => {
          this.error_message = error.response.data.status;
          this.notif_password_key++;
          this.change_password_error = true;
        })
        .finally(() => {
          this.is_loading_floating = false;
        });
    },
    saveProfile: function () {
      let api = process.env.VUE_APP_API_URL + "users-update";
      let params = {
        _id: this.user_data._id.$oid,
        nama: this.user_data.nama,
        username: this.user_data.username,
        email: this.user_data.email,
        phone: this.user_data.phone,
        role: btoa(parseInt(this.user_data.role)),
      };
      this.is_loading_floating = true;
      this.$http
        .post(api, params)
        .then((response) => {
          if (response.status == 200) {
            $("body")
              .pgNotification({
                style: "bar",
                message:
                  '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Data berhasil diupdate!',
                position: "top",
                timeout: 5000,
                type: "success",
              })
              .show();
          } else {
            $("#modalSlideUp").modal("hide");
            $("body")
              .pgNotification({
                style: "bar",
                message:
                  '<i class="bi bi-check-circle"></i> <b>Terjadi Kesalahan!</b> ' +
                  response.data,
                position: "top",
                timeout: 5000,
                type: "success",
              })
              .show();
          }
        })
        .catch((error) => {
          let stts = error.response.data.status;

          $("body")
            .pgNotification({
              style: "bar",
              message: '<i class="bi bi-x-circle"></i> <b>Error!</b> ' + stts,
              position: "top",
              timeout: 5000,
              type: "danger",
            })
            .show();
        })
        .finally(() => {
          this.is_loading_floating = false;
        });
    },
  },
  watch: {
    new_password_confirmation: function () {
      if (this.new_password_confirmation != this.new_password) {
        this.password_different = true;
      } else {
        this.password_different = false;
      }
    },
  },
  created: function () {
    let exp = 1592294217 * 1000;
    let d = new Date(exp);
    this.token_expire = gp.date(d).format();

    this.getData();
  },
  mounted: function () {
    this.mounted = true;
  },
};
</script>